import React, { Component } from 'react';
import logo from './img/logo.svg';
import styled from 'styled-components';
import { Grid, Row, Col } from 'react-flexbox-grid';

class App extends Component {
  render() {
    return (
        <Container>
          <Grid fluid>
            <Row middle="xs">
              <Col xs={12} lg={6}>
                <Image>
                </Image>
              </Col>
              <Col xs={12} lg={6}>
                <Text>
                Rich Cahill is an interaction designer working at IDEO.
              </Text>
              </Col>
            </Row>
          </Grid>
        </Container>
    );
  }
}

const Container = styled.div`
  margin-top: 20vh;
  background-color: #fff;
  &::selection {
    color: white;
    background-color: #F0598A;
  }
`

const Text = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1.5rem;
  margin: 40px;
  &::selection {
    color: white;
    background-color: #F0598A;
  }
`

const Image = styled.img`
  margin: 40px;
`


export default App;



// WEBPACK FOOTER //
// ./src/App.js